import { CellContext } from '@tanstack/react-table'
import { format, isToday } from 'date-fns'

export function DateCell<TData, TValue extends string | Date | undefined | null>(
  config: {
    format?: string
  } = {},
) {
  return ({ getValue }: CellContext<TData, TValue>) => {
    const value = getValue()
    return value ? (
      <div className="whitespace-nowrap">{f(value, config.format)}</div>
    ) : (
      <span />
    )
  }
}

function f(dateString: string | Date, fmt = 'MMM yyyy') {
  const date = new Date(dateString)
  if (isToday(date)) return 'Today'
  return format(date, fmt)
}
